export enum ProductionEnvironments {
  PRODUCTION = 'production',
  STAGING = 'staging',
  FEATURE = 'feature',
}
